import { type ReactNode, Suspense } from 'react';

import { LoadingPage } from '@nesso/ui/blocks/loading-page';

export function Page({ children }: { children: ReactNode }) {
    return (
        <Suspense fallback={<LoadingPage />}>
            <div className="h-dvh flex flex-col bg-background overflow-hidden pt-[env(safe-area-inset-top)] pr-[env(safe-area-inset-right)] pb-[env(safe-area-inset-bottom)] pl-[env(safe-area-inset-left)]">
                {children}
            </div>
        </Suspense>
    );
}
